import { useSelectMaximumStbPurchaseCount } from 'src/hooks/use-select-maximum-stb-purchase-count';

export const useSelectIsEligibleToPurchase = (): boolean => {
  const maximumStbPurchaseCount = useSelectMaximumStbPurchaseCount();

  return maximumStbPurchaseCount > 0;
};
